import * as React from "react";
import { Tabs, TabContent, TabPanel, TabLink, SortTableProvider } from "soprasteria-ui-library";
import { IMunicipalityTab } from "../../../../models/IMunicipalityDistrict";
import { ResidenceTab } from "./Residence/ResidenceTab"
import { ResidenceRequestTab } from "./ResidenceRequest/ResidenceRequestTab";
import { RoleGroupTab } from "./RoleGroup/RoleGroupTab";

interface IProps {
    selectedTab: IMunicipalityTab | undefined;
    hasAccessToResidenceRequest: boolean;
    hasAccessToUserRoleGroups: boolean;
    onTabSubmit: (message: string, tab: IMunicipalityTab) => void;
}

export const MunicipalityTabs: React.FC<IProps> = ({ selectedTab, hasAccessToResidenceRequest, hasAccessToUserRoleGroups, onTabSubmit }) => {
    const residenceTabSelected = selectedTab === undefined || selectedTab === IMunicipalityTab.residence;
    const residenceRequestTabSelected = selectedTab === IMunicipalityTab.residenceRequest;
    const roleGroupTabSelected = selectedTab === IMunicipalityTab.roleGroup;

    return (
        <section>
            <Tabs>
                <TabLink href="residences" id="residenceTab" text="Boendeenheter" selected={residenceTabSelected} />
                {
                    hasAccessToResidenceRequest && <TabLink href="residenceRequests" id="residenceRequestTab" text="Ansökningar boendeenheter" selected={residenceRequestTabSelected} />
                }
                {
                    hasAccessToUserRoleGroups && <TabLink href="roleGroups" id="roleGroupTab" text="Rollgrupper" selected={roleGroupTabSelected} />
                }
            </Tabs>
            <TabContent>
                <TabPanel id="residences" ariaLabelledBy="residenceTab" selected={residenceTabSelected}>
                    <SortTableProvider>
                        <ResidenceTab />
                    </SortTableProvider>
                </TabPanel>
                {
                    hasAccessToResidenceRequest &&
                    <>
                        <TabPanel id="residenceRequests" ariaLabelledBy="residenceRequestTab" selected={residenceRequestTabSelected}>
                            <SortTableProvider>
                                <ResidenceRequestTab canCreateNewRequest={hasAccessToResidenceRequest} onResidenceRequestSubmit={(message) => onTabSubmit(message, IMunicipalityTab.residenceRequest)} />
                            </SortTableProvider>
                        </TabPanel>
                    </>
                }
                {
                    hasAccessToUserRoleGroups &&
                    <>
                        <TabPanel id="roleGroups" ariaLabelledBy="roleGroupTab" selected={roleGroupTabSelected}>
                            <SortTableProvider>
                                <RoleGroupTab onRoleGroupSubmit={(message) => onTabSubmit(message, IMunicipalityTab.roleGroup)} />
                            </SortTableProvider>
                        </TabPanel>
                    </>
                }
            </TabContent>
        </section>
    )
}